import { immerable } from "immer";

export default class Pa {
  [immerable] = true;
  id: string;
  name: string;
  email: string;
  // ramal: string;
  // queues: Array<string>;
  config: object;
  hasMorgaCertificate: boolean;

  constructor(options: any) {
    this.id = options.id;
    this.name = options.nome;
    this.email = options.email;
    // this.ramal = options.ramal;
    // this.queues = options.fila || [];
    this.config = options.config;
    this.hasMorgaCertificate = options.morga;
  }
}
